import { Icon } from '../icon/icon.tsx'
import { Tooltip } from '../tooltip/tooltip.tsx'

type FormFieldInfoTooltipProps = { content: string }

const FormFieldInfoTooltip = ({ content }: FormFieldInfoTooltipProps) => (
  <Tooltip content={content}>
    <Icon
      className="self-center"
      name="information"
      size="sm"
      fill="solid"
      color="brand"
    />
  </Tooltip>
)

export { FormFieldInfoTooltip }
